import { Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EmployeeState} from '../../store/employee/employee.reducer';
import {Store} from '@ngrx/store';
import {TeamState} from '../../store/team/team.reducer';
import {Observable} from 'rxjs';
import * as fromEmployeeSelectors from '../../store/employee/employee.selectors';
import * as fromEmployeeActions from '../../store/employee/employee.actions';
import * as fromTeamsSelectors from '../../store/team/team.selectors';
import * as fromTeamsActions from '../../store/team/team.actions';
import { MatDialog } from '@angular/material/dialog';
import {TeamDialogComponent} from './team-dialog/team-dialog.component';
import {Predicate} from '@ngrx/entity';
import { TranslateService } from '@ngx-translate/core';
import {Department, EmployeeJobCode, IEmployee, ITeam} from '@signal/asp-data-commons';
import {  CdkDragMove } from '@angular/cdk/drag-drop';
import { TeamService } from '../../shared/services/team-service';
import * as fromTeamSelector from './../../store/team/team.selectors'
import { SubscriptionList } from '../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';


const speed = 10;

@Component({
  selector: 'app-team-management',
  templateUrl: './team-management.component.html',
  styleUrls: ['./team-management.component.scss']
})
export class TeamManagementComponent implements OnInit, OnDestroy {
  dialogConfig = {
    width: '25rem',
    height: '27.625rem',
    panelClass: 'asp-modal-container',
    disableClose:true,
    data:{clicked:true}
  };
  animationFrame: number | undefined;
  @ViewChild('teammanagercontainer')
  teamManagerContainer:ElementRef<HTMLElement>;

  employees: IEmployee[] = [];

  teams$: Observable<ITeam[]>;
  teamsCount$: Observable<number>;

  unassignedServiceAdvisors$: Observable<IEmployee[]>;
  unassignedServiceAdvisorsCount$: Observable<number>;

  unassignedServiceTechnicians$: Observable<IEmployee[]>;
  unassignedServiceTechniciansCount$: Observable<number>;
  isLoading$: Observable<boolean>;
  private subs: SubscriptionList = {};

  constructor(public readonly dialog: MatDialog,
              private translate: TranslateService,
              private readonly employeeState: Store<EmployeeState>,
              private readonly teamsState: Store<TeamState>,
              private readonly teamService: TeamService) {
  }

  ngOnInit() {
    this.isLoading$ = this.teamsState.select(fromTeamSelector.selectUpdateEmployeeTeam);
    
    this.setupStore();
  }
  itemsAdded(ev: IEmployee[], list) {
     this.teamService.dispatchEmployeeDetails();
  //  this.employeeState.dispatch(new fromEmployeeActions.UpdateTeamDetails({employees: ev.map(e => ({...e, teamId: null}))}))
  }
  itemsUpdated(ev: IEmployee[], list) {
     this.predicateSelector();
   //m this.employeeState.dispatch(new fromEmployeeActions.UpdateTeamDetails({employees: ev.map(e => ({...e, teamId: null}))}))
  }
  onAddNewTeam() {
    const dialogRef = this.dialog.open(TeamDialogComponent, this.dialogConfig);
    this.subs.dialog = dialogRef.afterClosed().subscribe(event =>{
      if(event.action === 'confirm'){
        this.teamsState.dispatch(new fromTeamsActions.AddTeam({team: {...event.data, department: Department.SERVICE}}))
      }
    });
  }

  public setupStore() {
    this.dispatchActions();
    this.predicateSelector();



    this.teams$ = this.teamsState.select(fromTeamsSelectors.selectNonTxmTeams);
    this.teamsCount$ = this.teamsState.select(fromTeamsSelectors.selectNonTxmTeamsCount);

  }
    /*triggerscroll based on movement cdk move*/
  cdkDragStarted(event){
    this.subs.cdkDrag = event.source.moved.subscribe(cdkmoveevent=>{
      this.triggerScroll(cdkmoveevent);
    });
  }
    public triggerScroll($event: CdkDragMove) {
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = undefined;
        }
        this.animationFrame = requestAnimationFrame(() => this.scrollMainContainer($event));

    }
    private scrollMainContainer($event: CdkDragMove) {
        const { y } = $event.pointerPosition;
      const baseEl = this.teamManagerContainer.nativeElement.parentElement.parentElement;
        const box = baseEl.getBoundingClientRect();
        const scrollTop = baseEl.scrollTop;
        const top = box.top + - y ;
        if (top > 0 && scrollTop !== 0) {
            const newScroll = scrollTop - speed * Math.exp(top / 50);
            baseEl.scrollTop = newScroll;
            this.animationFrame = requestAnimationFrame(() => this.scrollMainContainer($event));
            return;
        }

        const bottom = y - box.bottom ;
        if (bottom > 0 && scrollTop < box.bottom || scrollTop>574.5) {
            const newScroll = scrollTop + speed * Math.exp(bottom / 50);
            baseEl.scrollTop = newScroll;
            this.animationFrame = requestAnimationFrame(() => this.scrollMainContainer($event));
        }
    }

    private dispatchActions(){
      /* Store actions dispatchers */
      this.teamsState.dispatch(new fromEmployeeActions.LoadEmployees());
      this.teamsState.dispatch(new fromTeamsActions.LoadTeams({forceReload:true}));
    }

    private predicateSelector(){
      /* Predicates */
      const unassignedServiceAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.ADVISOR
        && e.isActive === true
        && !e.teamId
        && e.isTxm === false;

    const unassignedServiceTechnicianPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.TECHNICIAN
        && e.isActive === true
        && !e.teamId
        && e.isTxm === false;

    /* Store selectors */
    this.unassignedServiceAdvisors$ = this.employeeState.select(fromEmployeeSelectors.selectEmployeesByPredicate, {predicate: unassignedServiceAdvisorPredicate});
    this.unassignedServiceAdvisorsCount$ = this.employeeState.select(fromEmployeeSelectors.selectEmployeesCountByPredicate, {predicate: unassignedServiceAdvisorPredicate});

    this.unassignedServiceTechnicians$ = this.employeeState.select(fromEmployeeSelectors.selectEmployeesByPredicate, {predicate: unassignedServiceTechnicianPredicate});
    this.unassignedServiceTechniciansCount$ = this.employeeState.select(fromEmployeeSelectors.selectEmployeesCountByPredicate, {predicate: unassignedServiceTechnicianPredicate});
    }

    ngOnDestroy() {
      unsubscribeSubscriptions(this.subs);
    }
}
